/// <amd-module name="Search/Wiki/Flux/Stores/ZeroDataStore" />
import * as BaseZeroDataStore from "Search/Shared/Base/Stores/ZeroDataStore2";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub2";
import { areQueriesEqual } from "Search/Wiki/WikiUtils";
import { WikiSearchRequest, WikiSearchResponse, WikiResult } from "Search/WebApi/Contracts/Search.Shared";

export class ZeroDataStore extends BaseZeroDataStore.ZeroDataStore {
    public onResultsLoaded(request: WikiSearchRequest, payload: IResultsLoadedPayload<WikiSearchRequest, WikiSearchResponse, WikiResult>): void {
        if (areQueriesEqual(request, payload.request)) {
            const response = payload.response;

            if (response && response.count <= 0) {
                this._state.scenario =
                    BaseZeroDataStore.getScenario(response.infoCode, response.count, false);
            }

            this.emitChanged();
        }
    }
}